import { Data2, newId, dateToString } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { Currency } from '../../../tables/types/types'
import { useSystemStateHooks } from '../../system'
import { PaymentItem, PaymentOrder, PaymentOrderStatus, PaymentTicketItem, TaxItem } from '../state/types'

export const usePaymentOrderBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildPaymentOrder = (data: Data2) => {
        const {
            id = newId(),
            code,
            ticketItems,
            paymentItems,
            taxItems,
            payedAmount,
            status,
            creationDate,
            receiptUrl,
            archived
        } = data
        
        const paymentOrder: PaymentOrder = {
            companyId: companyId!,
            id: id! as string,
            code: code! as number,
            ticketItems: (ticketItems || []) as PaymentTicketItem[],
            paymentItems: (paymentItems || []) as PaymentItem[],
            taxItems: (taxItems || []) as TaxItem[],
            payedAmount: payedAmount! as number,
            status: (status || PaymentOrderStatus.EMITTED) as PaymentOrderStatus,
            creationDate: dateToString(creationDate || new Date())!,
            currency: Currency.ARS,
            receiptUrl: receiptUrl as O<string>,
            archived: !!archived
        }

        return paymentOrder
    }

    return {
        buildPaymentOrder
    }
}
